var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opened)?_c('div',{staticClass:"vx-popup-share",on:{"click":_vm.close}},[_c('img',{staticClass:"b1",attrs:{"src":"https://cdn01.xiaogj.com/uploads/x3/assets/m/img/share/005.png","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }